export const TTV_CONVERSION_COMPLETIONS_STORAGE_KEY =
  "audimee:ttv-conversion-completions:v1";
